module.exports = __webpack_public_path__ + "static/media/laundry.fc13c03e.svg";